import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import { wtFormatRoundedValue } from 'src/helpers/commons/utils'
import { wtGetDateTimeFormat } from 'src/helpers/commons/moment'
import JsBarcode from 'jsbarcode'
import { FRONT_BASE_URL } from 'src/config/Request'

const InventoryTransferPDF = (pdfData) => {
  const doc = new jsPDF()
  const logo = 'assets/wil-icon.png'
  let yPosition = 66.5
  const pageWidth = doc.internal.pageSize.width

  // Add logo and header on all pages
  const addLogoToAllPages = () => {
    const pageCount = doc.internal.getNumberOfPages()
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold')

      const pageWidth = doc.internal.pageSize.width
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold') //Header middle branch logo

      doc.addImage(logo, 'PNG', pageWidth - 200, 4, 25, 25)
      doc.line(pageWidth - 173, 7, pageWidth - 173, 27) // Adjust the coordinates as needed

      doc.setFontSize(11)
      doc.text('WAH', pageWidth - 171, 10, { align: 'left' })
      doc.setFontSize(11)
      doc.setFont('Helvetica')
      doc.text('INDUSTRIES', pageWidth - 171, 15)
      doc.text('LIMITED', pageWidth - 171, 20)
      doc.setFontSize(9)
      doc.text('www.wahindustries.com', pageWidth - 171, 25)
      doc.setFontSize(14)
      doc.text(`Outward Gate Pass`, pageWidth - 12, 10, { align: 'right' })
    }
  }
  addLogoToAllPages()


  doc.setFont('Helvetica', 'bold')
  doc.setTextColor('#0000')
  doc.setFontSize(13)
  doc.text('IT No : ', 15, 36, { align: 'left' })
  doc.setTextColor('#0202f7')
  doc.text(`${pdfData.id || ''}`, 31, 36, { align: 'left' })
  doc.setTextColor('#0000')

  doc.setFont('Helvetica', 'bold')
  doc.setFontSize(11)
  doc.text('Transfer Date : ', 15, 43, { align: 'left' })
  doc.setTextColor('#0202f7')
  doc.setFont('Helvetica', 'normal')
  doc.text(`${pdfData.transfer_date || ''}`, 45, 43, { align: 'left' })
  doc.setTextColor('#0000')


  doc.setFontSize(11)
  doc.setTextColor('#0000')
  doc.setFont('Helvetica', 'bold')
  doc.text('From Warehouse : ', 15, 48, { align: 'left' })
  doc.setTextColor('#0202f7')
  doc.setFont('Helvetica', 'normal')
  doc.text(`${pdfData.from_warehouse?.name || ''}`, 50, 48, { align: 'left' })
  doc.setTextColor('#0000')

  if (pdfData?.inventory_transfer_request) {
    // Top Info Section
    doc.setFont('Helvetica', 'bold')
    doc.setFontSize(13)
    doc.text('ITR Number :', 115, 36, { align: 'left' })
    doc.setTextColor('#0202f7')
    doc.text(`${pdfData.inventory_transfer_request_id || ''}`, 145, 36, { align: 'left' })


    doc.setFont('Helvetica', 'bold')
    doc.setTextColor('#0000')
    doc.text('To Warehouse : ', 115, 48, { align: 'left' })
    doc.setTextColor('#0202f7')
    doc.setFont('Helvetica', 'normal')
    doc.text(`${pdfData.inventory_transfer_request.warehouse?.name || ''}`, 150, 48, { align: 'left' })
    doc.setTextColor('#0000')

    const creationDate = pdfData.inventory_transfer_request.created_at ? moment(pdfData.inventory_transfer_request.created_at).format('DD MMMM YYYY') : ''
    const requiredDate = pdfData.inventory_transfer_request.required_date ? moment(pdfData.inventory_transfer_request.required_date).format('DD MMMM YYYY') : ''

    doc.setFontSize(11)
    doc.setTextColor('#000000')

    // Branch, Department, Project, Warehouse
    const infoFields = [
      { label: 'Branch:', value: pdfData.inventory_transfer_request.branch?.name || '', x: 15, y: 53 },
      { label: 'Department Name :', value: pdfData.inventory_transfer_request.department?.name || '', x: 15, y: 58 },
      { label: 'Project:', value: pdfData.inventory_transfer_request.project?.name || '', x: 15, y: 63 },
      { label: 'Required Date:', value: requiredDate, x: 115, y: 53 },
      { label: 'Created Date:', value: creationDate, x: 115, y: 58 },
      { label: 'Created By:', value: pdfData.created_by?.name || '', x: 115, y: 63 },
    ]

    infoFields.forEach((field) => {
      doc.setFont('Helvetica', 'bold')
      doc.setTextColor('#000000')
      doc.text(field.label, field.x, field.y)
      doc.setFont('Helvetica', 'normal')
      doc.setTextColor('#0202f7')
      doc.text(field.value, field.x + field.label.length * 2.2, field.y) // Adjust text position
    })
  }

  let finalY = yPosition
  // Table
  doc.autoTable({
    startY: yPosition + 5,
    head: [
      [
        { content: 'Sr#', styles: { fontStyle: 'bold', halign: 'center', cellWidth: 10 } },
        { content: 'Item Name', styles: { fontStyle: 'bold', halign: 'center', cellWidth: 50 } },
        { content: 'Unit', styles: { fontStyle: 'bold', halign: 'center', cellWidth: 20 } },
        { content: 'Brand', styles: { fontStyle: 'bold', halign: 'center', cellWidth: 30 } },
        { content: 'Qty', styles: { fontStyle: 'bold', halign: 'center', cellWidth: 15 } },
        { content: 'Serial', styles: { fontStyle: 'bold', halign: 'center', cellWidth: 57 } },
      ],
    ],
    body: pdfData.inventory_transfer_details?.map((data, index) => [
      { content: index + 1, styles: { halign: 'center', cellWidth: 10 } },
      { content: data?.item_name || '', styles: { halign: 'left', cellWidth: 50, textColor: [2, 2, 247] } },
      { content: data?.item_unit || '', styles: { halign: 'center', cellWidth: 20 } },
      { content: data?.item_brand || '', styles: { halign: 'center', cellWidth: 30 } },
      { content: wtFormatRoundedValue(data.qty, ''), styles: { halign: 'center', cellWidth: 15 } },
      {
        content: (data?.item_serials && data.item_serials.length > 0) ? data.item_serials.join(', ') : '-',
        styles: { halign: 'left', cellWidth: 57, overflow: 'linebreak' },
      },
    ]),
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    headStyles: { fillColor: [217, 218, 219] },
    styles: { lineColor: '#3c4b64', lineWidth: 0.2, font: 'helvetica' },
    didDrawPage: (data) => {
      finalY = data.cursor.y
    },
  })

  // Signature lines
  const lineWidth = 54
  const lineY = finalY + 22
  const leftLineX = 14
  const centerLineX = (pageWidth - lineWidth) / 2
  const rightLineX = pageWidth - lineWidth - 14

  doc.setLineWidth(0.35)
  doc.line(leftLineX, lineY, leftLineX + lineWidth, lineY)
  doc.line(centerLineX, lineY, centerLineX + lineWidth, lineY)
  doc.line(rightLineX, lineY, rightLineX + lineWidth, lineY)

  const preparedByName = pdfData.created_by?.name || ''
  const reviewedByName = pdfData.reviewed_by?.name || ''
  const approvedByName =
    pdfData.status === 2 ? pdfData.approved_by?.name || '' : pdfData.cancelled_by?.name || ''
  const preparedAtValue = pdfData.created_at ? wtGetDateTimeFormat(pdfData.created_at) : ''
  const reviewedAtValue = pdfData.reviewed_at ? wtGetDateTimeFormat(pdfData.reviewed_at) : ''
  const approvedAtValue =
    pdfData.status === 2
      ? pdfData.approved_at
        ? wtGetDateTimeFormat(pdfData.approved_at)
        : ''
      : pdfData.cancelled_at
        ? wtGetDateTimeFormat(pdfData.cancelled_at)
        : ''

  const drawFooterBlock = (name, label, dateTime, x) => {
    const centerX = x + lineWidth / 2

    doc.setFontSize(9)
    doc.setTextColor('#0202f7')
    doc.text(name, centerX, lineY - 4.5, { align: 'center', maxWidth: lineWidth + 4 })

    doc.setFontSize(8.5)
    doc.setTextColor('#000000')
    doc.text(label, centerX, lineY + 6.5, { align: 'center' })

    if (dateTime) {
      doc.setFontSize(8)
      doc.setTextColor('#4b5563')
      doc.text(dateTime, centerX, lineY + 11.5, { align: 'center', maxWidth: lineWidth + 8 })
    }
  }

  drawFooterBlock(preparedByName, 'Prepared By', preparedAtValue, leftLineX)
  drawFooterBlock(reviewedByName, 'Reviewed By', reviewedAtValue, centerLineX)
  drawFooterBlock(
    approvedByName,
    pdfData.status === 2 ? 'Approved By' : 'Cancelled By',
    approvedAtValue,
    rightLineX,
  )

  // Barcode
  const addBarCode = (doc) => {
    const qrCodeSize = 44
    const qrCodeX = (pageWidth - qrCodeSize) / 2
    const qrCodeY = doc.autoTable.previous.finalY + 50
    const canvas = document.createElement('canvas')
    JsBarcode(canvas, `${pdfData.id}-${pdfData.created_by_id}-${pdfData.company_id}`, {
      format: 'CODE128',
      displayValue: true,
      fontSize: 32,
    })
    const barcodeDataURL = canvas.toDataURL('image/png')
    doc.addImage(barcodeDataURL, 'PNG', qrCodeX, qrCodeY, 50, 20)
  }
  addBarCode(doc)

  // Footer
  const pageCount = doc.internal.getNumberOfPages()
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i)
    doc.setFontSize(9)
    doc.setTextColor('black')
    doc.line(14, 286, 196, 286)
    doc.text(`Page ${i} / ${pageCount}`, 190, 290, { align: 'right' })
  }

  // Open PDF
  const pdfBlob = doc.output('blob')
  const pdfUrl = URL.createObjectURL(pdfBlob)
  window.open(pdfUrl, '_blank')
}

export default InventoryTransferPDF
